module.exports = __webpack_public_path__ + "img/technology_icon_02.1182b7d7.png";